import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { DataService } from '../data.service';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

declare var RDStationForms: any;

@Component({
  selector: 'app-projetos',
  templateUrl: './projetos.component.html',
  styleUrls: ['./projetos.component.css']
})
export class ProjetosComponent implements OnInit {

  areaConhecimentoId$: Observable<any>;

  public data: any;
  public tipoProjetoId: any;
  public areaConhecimento: any;
  public projetos: any[];
  public projetosFiltrados: any[];
  public tiposProjeto: any[];

  constructor(
    public dataService: DataService,
    private route: ActivatedRoute,
    private router: Router) { }

  async ngOnInit() {

    const areaConhecimentoId = this.route.snapshot.paramMap.get("areaConhecimentoId")
    this.selectProjetos(areaConhecimentoId);

    this.route.paramMap.subscribe(params => {
      this.selectProjetos(params.get("areaConhecimentoId"));
    })

    // this.areaConhecimentoId$ = this.route.paramMap.pipe(
    //   switchMap((params: ParamMap) => this.selectProjetos(params.get('areaConhecimentoId')))
    // );

    // console.log(data);
    // this.projetos = data.projetos;
    // this.areaConhecimento = data.areasConhecimento[0];
    // console.log(this.areaConhecimento);
  }

  async selectProjetos(areaConhecimentoId) {
    this.data = (await this.dataService.getData()) as any;
    this.areaConhecimento = this.data.areasConhecimento.find(a => a.id == areaConhecimentoId);
    this.projetos = this.data.projetos
      .filter(p => p.imagem && p.nome)
      .filter(p => p.areaConhecimento && p.areaConhecimento.id == areaConhecimentoId);

    this.tiposProjeto = [];
    this.projetos.forEach(p => {
      const exists = this.tiposProjeto.map(tp => tp.id).includes(p.tipoProjeto.id);
      if (!exists) {
        this.tiposProjeto.push(p.tipoProjeto);
      }
    });

    this.selecionarTipoProjeto(-1);
  }

  selecionarTipoProjeto(tipoProjetoId) {
    this.tipoProjetoId = tipoProjetoId;
    if (tipoProjetoId == -1) {
      this.projetosFiltrados = this.projetos;
    } else {
      this.projetosFiltrados = this.projetos.filter(p => p.tipoProjeto.id == tipoProjetoId);
    }
    setTimeout(() => {
      switch (tipoProjetoId) {
        case 1:
          new RDStationForms('aditt-vitrine-tecnologica-projetos-de-extensao-430bf47c578c96e29d66', 'UA-2727336-2').createForm();
          break;
        case 2:
          new RDStationForms('aditt-vitrine-tecnologica-grupos-de-pesquisa-54fa110048947aa34d18', 'UA-2727336-2').createForm();
          break;
        default:
          new RDStationForms('aditt-vitrine-tecnologica-todas-98e6fcef536a18df9018', 'UA-2727336-2').createForm();
      }
    }, 100);
  }

  isSelected(tipoProjetoId) {
    return this.tipoProjetoId === tipoProjetoId;
  }
}
